module.exports = __webpack_public_path__ + "static/media/ic_report.9b54b782.svg";